import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

const useClassroomRosterChoicePost = () => {
  const setClassroomRosterChoicePost = useCallback((payload) => {
    return new Request(`${API_BASE_URL}/api/v2/roster-choice/`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    });
  }, []);

  return useRestMutation(setClassroomRosterChoicePost);
};

export default useClassroomRosterChoicePost;
